/**
 * Alarms Module
 *
 * Vuex module for managing device alarm history
 * Provides state management for alarm records retrieved via DeviceService
 *
 * @module store/modules/alarms
 */

import type { Module } from 'vuex';
import type { RootState } from '@/store/types';
import mutations, { initialAlarmsState } from './mutations';
import type { AlarmsState } from './mutations';
import getters from './getters';
import actions from './actions';

/**
 * Alarms Vuex module
 * Manages alarm history state with full TypeScript typing
 */
const module: Module<AlarmsState, RootState> = {
  namespaced: true,
  state: initialAlarmsState,
  mutations,
  getters,
  actions,
};

export default module;
export type { AlarmsState };
